<app-unauthorized-layout>
  <div class="login-container">
    <app-auth-left-panel
      [imageSrc]="'assets/images/airport.png'"
      imageAlt="Airport" class="login-image">
    </app-auth-left-panel>

    <div class="login-form-section">
    <img src="assets/images/logo.png" alt="Civil Aviation Authority" class="login-logo" />

    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <h2 class="login-title">{{ 'login.welcomeBack' | translate }}</h2>
      <!-- Error Alert -->
      @if (errorMessage) {
        <div class="error-message login-error">
          <strong>{{ errorMessage }}</strong>
        </div>
      }

      <!-- Username / Email -->
      <div class="form-group">
        <label for="username-or-email">{{ 'login.usernameOrEmail' | translate }}</label>
        <input
          type="text"
          id="username-or-email"
          class="form-control"
          formControlName="usernameOrEmail"
          [class.error]="form.get('usernameOrEmail')?.invalid && form.get('usernameOrEmail')?.touched"
          placeholder="{{ 'login.usernameOrEmail' | translate }}"
          autocomplete="username"
          required
          />
          @if (form.get('usernameOrEmail')?.invalid && form.get('usernameOrEmail')?.touched) {
            <div class="error-message field-error"
              >
              {{ 'login.usernameOrEmail' | translate }} is required
            </div>
          }
        </div>

        <!-- Password -->
        <div class="form-group">
          <label for="password">{{ 'login.password' | translate }}</label>
          <div class="password-wrapper">
            <input
              [type]="showPassword ? 'text' : 'password'"
              id="password"
              class="form-control"
              formControlName="password"
              [class.error]="form.get('password')?.invalid && form.get('password')?.touched"
              placeholder="{{ 'login.password' | translate }}"
              autocomplete="current-password"
              required
              />
              <button type="button" class="toggle-password" (click)="showPassword = !showPassword">
                <img [src]="showPassword ? 'assets/icons/eye-slash.svg' : 'assets/icons/eye.svg'"
                  alt="toggle password visibility" width="20" height="20" />
                </button>
              </div>
              @if (form.get('password')?.invalid && form.get('password')?.touched) {
                <div class="error-message field-error"
                  >
                  {{ 'login.password' | translate }} is required
                </div>
              }

            </div>

            <!-- Remember Me -->
            <div class="form-options">
              <label class="switch">
                <input type="checkbox" formControlName="rememberMe">
                <span class="slider"></span>
                <span class="label-text">{{ 'login.rememberMe' | translate }}</span>
              </label>
              <div class="forgot-inline">
                <a routerLink="/forgot-password">{{ 'login.forgotPassword' | translate }}</a>
              </div>
            </div>

            <!-- Login button -->
            <button type="submit" class="login-btn" [disabled]="isLoading || form.invalid">
              @if (isLoading) {
                <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                {{ 'common.loading' | translate }}
              } @else {
                {{ 'login.loginButton' | translate }}
              }
            </button>

            <!-- Links -->
            <div class="text-center mt-4">
              <p class="mb-2">
                {{ 'login.noAccount' | translate }}
                <a routerLink="/register" class="fw-semibold">{{ 'login.registerNewAccount' | translate }}</a>
              </p>
              <a routerLink="/forgot-password" class="fw-semibold d-block">
                {{ 'login.forgotPassword' | translate }}
              </a>
            </div>
          </form>
        </div>
         </div>
</app-unauthorized-layout>